<template>
  <div>
    <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
      <div class="uk-card-body">
        <div class="uk-overflow-auto">
          <table class="uk-table uk-table-hover uk-table-divider" v-if="sales.length">
            <thead>
              <tr>
                <th class="uk-table-shrink">#</th>
                <th class="uk-table-expand">Name</th>
                <th class="uk-width-small uk-preserve-width uk-text-right">Gesamt Netto</th>
                <th class="uk-width-small uk-text-center">Status</th>
                <th class="uk-width-small uk-text-right">Datum</th>
                <th class="uk-width-small"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="sale in sales" :key="sale.id">
                <td>
                  <router-link :to="{ name: 'admin.order.details', params: { id: sale.id } }">
                    {{ sale.number }}
                  </router-link>
                </td>
                <td>
                  {{ sale.details.company }}
                </td>
                <td class="uk-preserve-width uk-text-right">{{ sale.netAmount | euro }}</td>
                <td class="uk-text-center uk-text-nowrap">
                  <status-label :name="sale.status_name" :label="sale.status_label"></status-label>
                </td>
                <td class="uk-text-right">{{ sale.date }}</td>
                <td class="uk-text-nowrap">
                  <div class="uk-align-right uk-margin-right">
                    <a href="#" class="uk-icon-link" uk-icon="more"></a>
                    <div data-uk-dropdown="mode: click;animation: uk-animation-slide-top-small;">
                      <ul class="uk-nav uk-dropdown-nav uk-text-left">
                        <li>
                          <router-link :to="{ name: 'admin.order.details', params: { id: sale.id } }">
                            Details
                          </router-link>
                        </li>
                        <li class="uk-nav-divider uk-margin-remove"></li>
                        <li>
                          <a class="uk-text-danger uk-dropdown-close" href="#" @click.prevent="remove(sale.id)">
                            <span class="uk-icon" data-uk-icon="icon: trash"></span>&nbsp; Löschen
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--
          <table class="uk-table uk-table-middle uk-table-divider" v-if="sales.length">
            <thead>
              <tr>
                <th class="uk-width-small">Datum</th>
                <th class="uk-width-small">Bestell-Nr.</th>
                <th>Fahrzeug</th>
                <th>Preis Netto</th>
                <th class="uk-width-small">Bestellung (PDF)</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="sale in sales">
                <tr v-for="(item, key) in sale.items" :key="item.id">
                  <td v-if="key == 0">{{ sale.date }}</td>
                  <td v-else>&nbsp;</td>
                  <td v-if="key == 0">{{ sale.number }}</td>
                  <td v-else>&nbsp;</td>
                  <td>
                    {{ item.make }} {{ item.model }} {{ item.edition }}<br />
                    <span class="uk-text-small"> Nr.: {{ item.carId }} </span>
                  </td>
                  <td>{{ item.price }}</td>
                  <td>
                    <a
                      href="#"
                      class="uk-text-primary uk-align-right uk-margin-right"
                      :uk-icon="'icon: download'"
                      @click.prevent="getContractPdf(item.id)"
                      v-if="requestDownload !== item.id"
                    ></a>
                    <div uk-spinner v-if="requestDownload === item.id" class="uk-align-right"></div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          -->
        </div>
        <div v-if="!sales.length" class="uk-margin-remove uk-h4">
          Keine Bestellungen vorhanden!
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StatusLabel from '@/components/StatusLabel'
import SaleService from '@/services/sale.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
export default {
  props: {
    sales: {
      required: true
    }
  },
  components: {
    StatusLabel
  },
  data() {
    return {
      requestDownload: null
    }
  },
  methods: {
    getPdf(id) {
      this.requestDownload = id
    },
    remove(id) {
      const $this = this
      this.$uikit.modal
        .confirm('Bestellung wirklich löschen?', {
          labels: {
            cancel: 'Abbrechen',
            ok: 'Löschen'
          }
        })
        .then(
          function() {
            SaleService.delete(id).then(() => {
              iziToast.success({
                position: 'topCenter',
                title: 'OK',
                message: 'Bestellung gelöscht!'
              })
              $this.$emit('removed')
            })
          },
          function() {
            //
          }
        )
    },
  }
}
</script>
